(function () {
  const INITIALIZED_ATTR = 'data-mega-menu-promo-initialized';

  function initPromoSliders() {
    if (typeof Swiper === 'undefined') return;
    const sliders = document.querySelectorAll(
      '[data-mega-menu-promo-slider]:not([' + INITIALIZED_ATTR + '])'
    );

    sliders.forEach(function (el) {
      try {
        new Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          freeMode: true,
          grabCursor: true,
          mousewheel: {
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
          },
          observer: true,
          observeParents: true,
        });
        el.setAttribute(INITIALIZED_ATTR, 'true');
      } catch (err) {
        console.warn('Mega menu promo slider init failed:', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoSliders);
  } else {
    initPromoSliders();
  }

  document.addEventListener('shopify:section:load', initPromoSliders);
  document.addEventListener('shopify:block:select', initPromoSliders);
})();
